import { WidgetsOverlay } from './WidgetsOverlay';
import { styled } from "styled-components";
import Theme from '../../styles/Theme/Theme';
import { useState } from 'react';
import { useGlobalFilterContext } from '../../contexts/GlobalFilterProvider';
import { MapsComponent } from '../Global/Molecules/Maps/MapsComponent';
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const BackgroundMap = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
`;

// Styling for the overlay
const Overlay = styled.div`
    padding: ${Theme.spacing['s07']} ${Theme.spacing['s06']};
`;
//#endregion

// Map component function
export const Map = ({ city }) => {
    const { entityToFetch, subEntityToFetch } = useGlobalFilterContext();
    // State variables to manage the visibility of different buttons
    const [showBTN, setShowBTN] = useState(true);
    const [showBTE, setShowBTE] = useState(true);
    const [showMT, setShowMT] = useState(true);
    const [showAT, setShowAT] = useState(true);
    const [showBTN_IP, setShowBTN_IP] = useState(true);

    // Function to handle visibility of BTN button
    const handleBTN = (value) => {
        try {
            setShowBTN(value)
        } catch (error) {
            console.error('(Map page) Error in handling BTN:', error);
            //reportError(error); // Send error report to backend
        }
    }

    // Function to handle visibility of BTE button
    const handleBTE = (value) => {
        try {
            setShowBTE(value)
        } catch (error) {
            console.error('(Map page) Error in handling BTE:', error);
            //reportError(error); // Send error report to backend
        }
    }

    // Function to handle visibility of MT button
    const handleMT = (value) => {
        try {
            setShowMT(value)
        } catch (error) {
            console.error('(Map page) Error in handling MT:', error);
            //reportError(error); // Send error report to backend
        }
    }

    // Function to handle visibility of AT button
    const handleAT = (value) => {
        try {
            setShowAT(value)
        } catch (error) {
            console.error('(Map page) Error in handling AT:', error);
            //reportError(error); // Send error report to backend
        }
    }

    const handleBTN_IP = (value) => {
        try {
            setShowBTN_IP(value)
        } catch (error) {
            console.error('(Map page) Error in handling BTN-IP:', error);
            //reportError(error); // Send error report to backend
        }
    }

    // Rendering JSX
    return (
        <>
            {/* Background map */}
            <BackgroundMap>
                {subEntityToFetch || entityToFetch ?
                    <MapsComponent mapId="mapPOIS" BTN={showBTN} BTE={showBTE} MT={showMT} AT={showAT} BTN_IP={showBTN_IP} />
                    : null}
            </BackgroundMap>
            {/* Overlay for widgets */}
            <Overlay>
                <WidgetsOverlay showBTN={handleBTN} showBTE={handleBTE} showMT={handleMT} showAT={handleAT} showBTN_IP={handleBTN_IP} city={city} />
            </Overlay>
        </>
    )
}
